import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import HeroSection from '../components/MarketingPage/HeroSection';
import StatsSection from '../components/MarketingPage/StatsSection';
import FeaturesSection from '../components/MarketingPage/FeaturesSection';
import HowItWorksSection from '../components/MarketingPage/HowItWorksSection';
import ProblemSolutionSection from '../components/MarketingPage/ProblemSolutionSection';
import TestimonialsSection from '../components/MarketingPage/TestimonialsSection';
import PricingSection from '../components/MarketingPage/PricingSection';
import FaqSection from '../components/MarketingPage/FaqSection';
import ContactSection from '../components/MarketingPage/ContactSection';
import CtaBannerSection from '../components/MarketingPage/CtaBannerSection';
import PrivacyPolicy from '../components/MarketingPage/PrivacyPolicy';
import Footer from '../components/MarketingPage/Footer';
import DemoModal from '../components/MarketingPage/DemoModal';
import ResetPasswordModal from '../components/MarketingPage/ResetPasswordModal';

const MarketingPage = () => {
    const [demoOpen, setDemoOpen] = useState(false);
    const [loginOpen, setLoginOpen] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();

    const resetToken = searchParams.get('resetToken');

    const openDemo  = () => setDemoOpen(true);
    const closeDemo = () => setDemoOpen(false);

    const openLogin  = () => setLoginOpen(true);
    const closeLogin = () => setLoginOpen(false);

    const closeResetModal = () => {
        // Remove resetToken param from URL without full navigation
        searchParams.delete('resetToken');
        setSearchParams(searchParams, { replace: true });
    };

    return (
        <div>
            <HeroSection         onOpenDemo={openDemo} loginOpen={loginOpen} onOpenLogin={openLogin} onCloseLogin={closeLogin} />
            <StatsSection />
            <FeaturesSection     onOpenDemo={openDemo} />
            <HowItWorksSection   onOpenDemo={openDemo} />
            <ProblemSolutionSection />
            <TestimonialsSection />
            <PricingSection      onOpenDemo={openDemo} />
            <FaqSection />
            <ContactSection      onOpenDemo={openDemo} />
            <CtaBannerSection    onOpenDemo={openDemo} />
            <PrivacyPolicy />
            <Footer              onOpenDemo={openDemo} />
            <DemoModal isOpen={demoOpen} onOpen={openDemo} onClose={closeDemo} />

            {resetToken && (
                <ResetPasswordModal
                    token={resetToken}
                    onClose={closeResetModal}
                    onLoginOpen={openLogin}
                />
            )}
        </div>
    );
};

export default MarketingPage;
